import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Lock, ArrowLeft, Loader2 } from "lucide-react";
import { usePlanCatalog } from "@/hooks/usePlanCatalog";
import { useTenantPlan } from "@/hooks/useTenantPlan";
import { UpgradePlanModal } from "./UpgradePlanModal";
import { FEATURE_CATALOG } from "./plan-constants";
import type { FeatureKey } from "@/hooks/useTenantPlan";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  featureKey: FeatureKey;
  featureLabel?: string;
}

export function FeatureLockedModal({ open, onOpenChange, featureKey, featureLabel }: Props) {
  const { planName } = useTenantPlan();
  const { getMinPlanForFeature, isLoading } = usePlanCatalog();
  const [upgradeOpen, setUpgradeOpen] = useState(false);

  const feature = FEATURE_CATALOG.find((f) => f.key === featureKey);
  const Icon = feature?.icon;
  const label = featureLabel || feature?.label || featureKey;
  const minPlan = getMinPlanForFeature(featureKey);

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-md text-center">
          <DialogHeader className="items-center space-y-4">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-amber-500/10">
              {Icon ? <Icon className="h-8 w-8 text-amber-500" /> : <Lock className="h-8 w-8 text-amber-500" />}
            </div>
            <DialogTitle className="text-xl">
              {label}
            </DialogTitle>
            <DialogDescription className="text-base space-y-1">
              <span>
                Este módulo não está disponível no seu plano <strong>{planName || "atual"}</strong>.
              </span>
              <br />
              {isLoading ? (
                <Loader2 className="h-4 w-4 animate-spin inline" />
              ) : minPlan ? (
                <span>
                  Disponível a partir do plano <strong className="text-foreground">{minPlan}</strong>.
                </span>
              ) : (
                <span>Entre em contato para mais informações.</span>
              )}
            </DialogDescription>
          </DialogHeader>

          <div className="flex flex-col gap-3 mt-4">
            <Button
              onClick={() => {
                onOpenChange(false);
                setUpgradeOpen(true);
              }}
              className="gap-2"
            >
              Ver planos
            </Button>
            <Button variant="ghost" onClick={() => onOpenChange(false)} className="gap-2">
              <ArrowLeft className="h-4 w-4" />
              Voltar
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <UpgradePlanModal open={upgradeOpen} onOpenChange={setUpgradeOpen} />
    </>
  );
}
